import { apiClient } from './ApiClient';
export const authApi = {
    async login(credentials) {
        const response = await apiClient.post('/auth/login', credentials);
        // Set CSRF token from response
        if (response.data.csrfToken) {
            apiClient.setCsrfToken(response.data.csrfToken);
        }
        return {
            user: response.data.user,
            expiresAt: response.data.expiresAt,
        };
    },
    async logout() {
        await apiClient.post('/auth/logout');
        apiClient.setCsrfToken(null);
    },
    async validateSession() {
        try {
            const response = await apiClient.get('/auth/me');
            // Set CSRF token from response
            if (response.data.csrfToken) {
                apiClient.setCsrfToken(response.data.csrfToken);
            }
            return {
                user: response.data.user,
                expiresAt: '', // /auth/me doesn't return expiresAt
            };
        }
        catch {
            return null;
        }
    },
};
